module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "178",
      "src": "images/f0011-01.jpg",
      "width": "550"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "fos"
  }, [_vm._v("1")])])])]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("LIVE CARGO!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("A")])]), _vm._v(" WILD, ringing neigh shrilled up from the hold of the Spanish galleon. It was not the cry of an animal in hunger. It was a terrifying bugle. An alarm call.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The captain of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Santo Cristo")]), _vm._v(" strode the poop deck. “Cursed be that stallion!” he muttered under his breath as he stamped forward and back, forward and back.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("Suddenly he stopped short. The wind! It was dying with the sun. It was spilling out of the sails, causing them to quiver and shake. He could feel his flesh creep with the sails. Without wind he could not get to Panama. And if he did not get there, ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("and get there soon, he was headed for trouble. The Moor ponies to be delivered to the Viceroy of Peru could not be kept alive much longer. Their hay had grown musty. The water casks were almost empty. And now this sudden calm, this heavy warning of a storm.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He plucked nervously at his rusty black beard as if that would help him think. “We lie in the latitude of white squalls,” he said, a look of vexation on his face. “When the wind does strike, it will strike with fury.” His steps quickened. “We must shorten sail,” he made up his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cupping his hands to his mouth, he bellowed orders: “Furl the topgallant sail! Furl the coursers and the maintopsail! Shorten the fore-topsail!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ship burst into action. From forward and aft all hands came running. They fell to work furiously, carrying out orders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The captain’s eyes were fixed on his men, but his thoughts raced ahead to the rich land where he was bound. In his mind’s eye he could see the mule train coming to meet him when he reached land. He could see it snaking its way along the Gold Road from Panama to the seaport of Puerto Bello. He could almost feel the smooth, hard gold in the packs on the donkeys’ backs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("His eyes narrowed greedily. “Gold!” he mumbled. “Think of trading twenty ponies for their weight in gold!” He clasped his hands behind him and resumed his pacing and muttering. “The Viceroy of Peru sets great store by the ponies, and well he ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("may. Without the ponies to work the mines, there will be no more gold.” Then he clenched his fists. “We must keep the ponies alive!”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("His thoughts were brought up sharply. That shrill horse call! Again it filled the air about him with a wild ring. His beady eyes darted to the lookout man in the crow’s-nest, then to the men on deck. He saw fear spread among the crew.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "353",
      "src": "images/f0013-01.jpg",
      "width": "550"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, in the dark hold of the ship, a small bay stallion was pawing the floor of his stall. His iron shoes with their sharp rims and turned-down heels threw a shower of sparks, and he felt strong charges of electricity. His nostrils flared. The moisture in the air! The charges of electricity! These were storm warnings—things he knew. Some inner urge told him he must get his mares to high land before the storm broke. He tried to escape, charging against the chest board of his stall again and again. He threw his head back and bugled.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    staticClass: "imagefw",
    attrs: {
      "alt": "Images",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("From stalls beside him and from stalls opposite him, nineteen heads with small pointed ears peered out. Nineteen pairs of brown eyes whited. Nineteen young mares caught his anxiety. They, too, tried to escape, rearing and plunging, rearing and plunging.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But presently the animals were no longer hurling themselves. They were "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("being")]), _vm._v(" hurled. The ship was pitching and tossing to the rising swell of the sea, flinging the ponies forward against their chest boards, backward against the ship’s sides.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A cold wind spiraled down the hatch. It whistled and screamed above the rough voice of the captain. It gave way only to the deep "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("flump-flump")]), _vm._v(" of the thunder.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("The sea became a wildcat now, and the galleon her prey. She stalked the ship and drove her off her course. She slapped at her, rolling her victim from side to side. She knocked the spars out of her and used them to ram holes in her sides. She ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("clawed the rudder from its sternpost and threw it into the sea. She cracked the ship’s ribs as if they were brittle bones. Then she hissed and spat through the seams.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The pressure of the sea swept everything before it. Huge baskets filled with gravel for ballast plummeted down the passageway between the ponies, breaking up stalls as they went by.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly the galleon shuddered. From bow to stern came an endless rasping sound! The ship had struck a shoal. And with a ripping and crashing of timber the hull cracked open. In that split second the captain, his men, and his live cargo were washed into the boiling foam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wildcat sea yawned. She swallowed the men. Only the captain and fifteen ponies managed to come up again. The captain bobbed alongside the stallion and made a wild grasp for his tail, but a great wave swept him out of reach.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The stallion neighed encouragement to his mares, who were struggling to keep afloat, fighting the wreckage and the sea. For long minutes they thrashed about helplessly, and just when their strength was nearly spent, the storm died as suddenly as it had risen. The wind calmed.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The sea was no longer a wildcat. She became a kitten, fawning and lapping about the ponies’ legs. Now their hooves touched land. They were able to stand! They were scrambling up the beach, up on Assateague Beach, that long, sandy island which shelters the tidewater country of Virginia and Maryland. They were far from the mines of Peru.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "400",
      "src": "images/f0016-01.jpg",
      "width": "550"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0